import i18n from "@/translations/i18n"

export const PASSWORD_RULES = {
  lowercaseCount: {
    message: i18n.t("validation:passwordRulesLowercaseCount"),
    value: /^(?=.*[a-z])/,
  },
  minlength: {
    message: i18n.t("validation:passwordRulesMinLength"),
    value: /^(?=.{8})/,
  },
  numericCount: {
    message: i18n.t("validation:passwordRulesNumericCount"),
    value: /^(?=.*\d)/,
  },
  specialCharacterCount: {
    message: i18n.t("validation:passwordRulesSpecialCharacterCount"),
    value: /^(?=.*[!#$%&*@^])/,
  },
  uppercaseCount: {
    message: i18n.t("validation:passwordRulesUppercaseCount"),
    value: /^(?=.*[A-Z])/,
  },
}
